import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    taxonsMenu: [],
    fetchedTaxons: [],
};

const taxons = (state = initialState, action) => {
    if (action.type === APP_ACTIONS.ADD_TAXONS) {
        return { ...action.payload };
    }
    return state;
};

export default taxons;



/** WEBPACK FOOTER **
 ** ./src/reducers/taxons.js
 **/